<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu />
        <div id="top" class="content-wrapper">
        <div  class="container-wrapper center">
          <div class="modal-custom" v-show="showOverlay">
            <div class="loader-img-center">
              <i class="fa fa-spinner fa-spin"></i> Please wait...
            </div>
          </div>
          <div>
            <h3 class="d-inline heading">Introduction Manager</h3>
            <button
                v-on:click="isModalVisible = true, verrors.clear()"
                class="btn btn-red btn-md input-height-15 float-right text-align-right"
                ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Introduction</button>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

          <div class="">
            <b-navbar toggleable="lg" type="light" variant="light">
              <b-navbar-brand href="#">Filter/Search</b-navbar-brand>

              <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>


              <b-collapse id="nav-collapse" is-nav>
          <div class="search-wrapper col-12">

          <div class="row col-12 override-padding">
            <div
              :class="((masterAdmin === true) && (!$store.state.switch_admin_username)) ? 'col-lg-4 col-md-12 col-12' : 'col-lg-7 col-md-12 col-12'"
              >
            <b-form-input
              class="input-text"
              v-model="search_keyword"
              type="text"
              placeholder="Search by Title"
              @keyup.enter="filterIntroductionitems()"
              maxlength="255"
            ></b-form-input>
            </div>
            <div class="col-lg-3 col-md-10 col-10">
               <b-form-select
                class="input-text"
                v-model="search_status"
                :options="status_options"
                @change="filterIntroductionitems()"
              >
              </b-form-select>
            </div>
            <div class="col-lg-3 col-md-10 col-10">
               <b-form-select
                class="input-text"
                v-model="search_affiliate"
                :options="affiliate_options"
                @change="filterIntroductionitems()"
              >
              </b-form-select>
            </div>
            <div class="col-lg-1 col-md-2 col-2 search-icon-wrapper cursor-pointer" @click="filterIntroductionitems()">
            <span class="search-icon">
              <i class="fa fa-search"></i>
            </span>
            </div>
            <div class="col-lg-1 col-md-2 col-2 scroll_box cursor-pointer">
              <span class="scroll_up_down" @click="scrollToElement('down')">
                <i class="fa fa-angle-down angle_font"></i>
              </span>
            </div>
            </div>

          </div> 
          </b-collapse>
        </b-navbar>
      </div>

          <div class="margin-bottom-10"></div>
                <div v-if="rows > 25" class="overflow-auto float-right pagination-wrapper" style="margin: 0;">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    v-bind:hide-goto-end-buttons=true
                    @input="showTasklistofPaginated()"
                    ></b-pagination>
                </div>
                <div style="clear: both"></div>
          <div>
                 <div class="row tasks_heading_row">
                   <div
                     class="bold cursor-pointer col-3"
                     v-on:click="sortMethod('introductionTitle')"
                     >
                     Title
                     <i v-if="sortField == 'introductionTitle' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'introductionTitle' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-1 override-padding"
                     v-on:click="sortMethod('status')"
                     >
                     Status
                     <i v-if="sortField == 'status' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'status' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold col-3 override-padding"
                     >
                     Affiliate
                     
                   </div>
                   <div
                     class="bold cursor-pointer col-2 override-padding"
                     v-on:click="sortMethod('createdBy')"
                     >
                     Created By
                     <i v-if="sortField == 'createdBy' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'createdBy' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-1 override-padding"
                     v-on:click="sortMethod('createdAt')"
                     >
                     Added
                     <i v-if="sortField == 'createdAt' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'createdAt' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-1 override-padding"
                     v-on:click="sortMethod('updatedAt')"
                     >
                     Updated
                     <i v-if="sortField == 'updatedAt' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'updatedAt' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold col-1 override-padding text-align-right" style="padding-right: 20px;"
                     >
                     &nbsp;
                   </div>
                 </div>


                 <!-- No Introduction Manager Text -->
                 <div v-if="introduction_lists.length == 0 && loading == false" style="background-color: #FFF; min-height: 480px; padding-top: 180px;" class="col-12 text-align-center">
                  <div class="col-12 text-align-center no-assessment-text">No introduction manager created</div>
                  <button
                    v-on:click="isModalVisible = true, verrors.clear()"
                    class="btn btn-white col-2 override-padding" style="margin-top: 10px; height: 35px; border-radius: 10px; font-weight: bold;"
                    >Create Introduction</button>
 
                 </div>
                <div v-show="loading" class="loading_show">
                  <div class="spinner-border text-danger"></div>
                </div>
                <div class="card-text" v-if="introduction_lists.length > 0">
                <div class="tasklists-row" v-for="(list, index) in introduction_lists">
                  <div class="row tasklist-item" style="margin: 0;">
                    <div
                      class="col-3"
                      >
                      {{list.introductionTitle}}
                    </div>
                    <div class="col-1 override-padding">{{ getStatus(list.status) }}</div>
                    <div class="col-3 override-padding text-left">{{ list.affiliate_name }}</div>
                    <div class="col-2 override-padding">{{ truncate(list.created_by) }}</div>
                    <div class="col-1 override-padding">{{FollowDate(list.createdAt)}}</div>
                    <div class="col-1 override-padding">{{FollowDate(list.updatedAt)}}</div>
                    <div class="col-1 override-padding">
                      <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')" >
                        <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index" >
                          <li></li>
                          <li></li>
                          <li></li>
                        </ul>
                        <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                          <div class="action-dd-menu" href="" @click="editIntroductionMethod(list.id)"><i class="cursor-pointer fa fa-edit spacer-icon"></i>Edit</div>
                          <div class="action-dd-menu" v-if="list.status == 'DRAFT'" @click="updateTasklistStatus(list.id, 'PUBLISH')"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Publish</div>
                          <div class="action-dd-menu" v-if="list.status == 'PUBLISH'" @click="updateTasklistStatus(list.id, 'DEACTIVATED')"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Deactivate</div>
                          <div class="action-dd-menu" href="" v-if="list.status=='DRAFT' || list.status=='DEACTIVATED'" @click="deleteIntroductionConfirm(list.id)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Remove</div>
                          <div class="action-dd-menu" href="" @click="prviewIntroduction(list.id)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Preview</div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div><hr></div>
                </div>


                       <div class="row page_to_down">
                          <div class="mx-auto">
                            <div v-if="rows > 25" class="overflow-auto float-right pagination-wrapper" style="margin-bottom: 0;">
                              <b-pagination
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                                first-text="First"
                                prev-text="Prev"
                                next-text="Next"
                                last-text="Last"
                                v-bind:hide-goto-end-buttons=true
                                @input="showTasklistofPaginated()"
                                ></b-pagination>
                            </div>
                          </div>
                          <div class="page_angle_down">
                            <div class="scroll_box cursor-pointer">
                              <span class="scroll_up_down" @click="scrollToElement('up')">
                                <i class="fa fa-angle-up angle_font"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                </div>
         </div>
      </div>


      </div>
    </div>
    <createIntroductionModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Create Introduction</h3></div>
      <div slot="body">

        <div class="col-12 override-padding">
          <input v-model="introduction_title"
                name="introduction_title"
                placeholder="Enter Title..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'"
                maxlength="255" />
         <div v-if="verrors.firstByRule('introduction_title', 'required')" class="margin-bottom-5 validate-warning-msg">Introduction Manager Title is required</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <multiselect
            v-model="affiliate_selected"
            :options="affiliate_options" track-by="text" label="text"
            placeholder="Select Affiliates..." :multiple="true"  :close-on-select="false" :show-labels="false"
            v-validate="'required'"
            name="affiliate"
            id="affiliate"
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
          </multiselect>
          <div v-if="verrors.firstByRule('affiliate', 'required')" class="margin-bottom-5 validate-warning-msg">Affilates is required</div>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
  
        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <multiselect
            v-model="roles_selected"
            :options="roles_options"
            track-by="name" label="name"
            placeholder="Select Users..."
            :multiple="true" 
            :close-on-select="false"
            :show-labels="false"
            v-validate="'required'"
            name="roles"
            id="roles"
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
      

          </multiselect>
          <div v-if="verrors.firstByRule('roles', 'required')" class="margin-bottom-5 validate-warning-msg">Users is required</div>

          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <input
            type="checkbox"
            v-bind:id="show_slide_number"
            v-bind:name="show_slide_number"
            ref="show_slide_number"
            v-model="show_slide_number_selected"
            :checked="show_slide_number_checked"
            :value="1" style="margin-top: 4px;">
          <label class="" for="submit_comment_1" style="color: #002F42;">Show Slide Numbers</label>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>


        <div class="col-12 override-padding text-align-right">
          <button
              v-on:click="createIntroduction()"
              class="btn btn-red col-lg-3"
              style="line-height: 30px;"
              ><b>Create</b></button>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </createIntroductionModal>

    <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure you want to delete?</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="deleteIntroduction(id)">Confirm</button>
      </div>
    </DeleteModal>

    <IntroductionModal
    :isIntroductionModalVisible="isIntroductionModalVisible"
    :introductionId="introductionId"
    ref="introduction_modal"
    @close="isIntroductionModalVisible = false"
    >

    </IntroductionModal>



  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import VeeValidate from 'vee-validate';
import createIntroductionModal from '../admin/create-tasklist-modal.vue';
import IntroductionModal from '../admin/introductionTemplateModalPreview.vue';
import Multiselect from 'vue-multiselect';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import DeleteModal from '../shared/delete_modal_alert.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
        data() {
          return {
            filterFlag: false,
            id: '',
            rows: 0,
            perPage: 25,
            currentPage: 1,
            introduction_lists: [],
            search_status: '',
            status_options: [
              { value: '', text: 'Status' },
              { value: 'DRAFT', text: 'Draft' },
              { value: 'PUBLISH', text: 'Published' },
              { value: 'DEACTIVATED', text: 'Deactivated' }
            ],
            task_lists: [],
            private_task_lists: [],
            masterAdmin: false,
            admin: false,
            search_keyword: '',
            loading: false,
            sortField: 'introductionTitle',
            sortBy: 'ASC',
            search_affiliate: '',
            user_options: [],
            isModalVisible: false,
            introduction_title: '',
            affiliate_options: [],
            index: 1,
            roles_options: [
              {
                name: 'Admin',
                value: 'ROLE_ADMIN',
              },
              {
                name: 'Mentor',
                value: 'ROLE_MENTOR',
              },
              {
                name: 'Mentee',
                value: 'ROLE_MENTEE',
              },
              {
                name: 'Apprentice',
                value: 'ROLE_APPRENTICE',
              },
              {
                name: 'Instructor',
                value: 'ROLE_INSTRUCTOR',
              },
              {
                name: 'Student',
                value: 'ROLE_STUDENT',
              },
            ],
            affiliate_selected: [],
            roles_selected: [],
            id: '',
            deactivateId: '',
            activateId: '',
            isDeleteModalVisible: false,
            isActivateModalVisible: false,
            isDeactivateModalVisible: false,
            isDeactivateValidateModalVisible: false,
            showOverlay: false,
            isPublishModalVisible: false,
            assessmentTitle: '',
            apiUrl: '',
            isDeleteModalVisible: false,
            isIntroductionModalVisible: false,
            introductionId: '',
            show_slide_number_checked: 1,
            show_slide_number_selected: true,
          }
        },

        components: {
          UserMenu,
          GoBack,
          MasteradminSidebarMenu,
          createIntroductionModal,
          Multiselect,
          DatePicker,
          DeleteModal,
          IntroductionModal,
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            prviewIntroduction(introduction_id) {
              this.introductionId = introduction_id;
              this.$refs.introduction_modal.getIntroduction(introduction_id);
              this.isIntroductionModalVisible = true;
            },

            updateTasklistStatus(introduction_id, status_text) {
              this.showOverlay = true;
              axios('/introduction-manager/' + introduction_id,
               {
                 method: 'PATCH',
                 data: { "status": status_text},
               }
              )
              .then((resp) => {
                this.showOverlay = false;
                this.fetchIntroductionitems();
              })
              .catch(error => {
                  if(error.response.data.message == 'Access denied.') {
                    router.push("/forbidden");
                  }
              });
            },

            scrollTo: function(arg) {
              if(arg == 'Top') {
                let elmnt = document.getElementById('top');
                elmnt.scrollIntoView(true);
              }
              else {
                let elmnt = document.getElementById('top');
                elmnt.scrollIntoView(false);
              }
            },
            truncate: function (text) {
              if (text.length > 20) {
                  return text.substring(0, 20) + '...';
              } else {
                  return text;
              }
            },
            createIntroductionButton: function() {
              this.isModalVisible = true;
            },
            editIntroductionMethod: function(introduction_id) {
              this.$store.dispatch('introduction_template', '');
              router.push("/introduction-slide-list/" + introduction_id);
            },
            deleteIntroductionConfirm: function(introduction_id) {
              this.isDeleteModalVisible = true;
              this.id = introduction_id;
            },
            deleteIntroduction: function(introduction_id) {
              this.isDeleteModalVisible = false;
              this.showOverlay = true;
              axios('/introduction-manager/' + introduction_id,
                 {
                   method: 'DELETE',
                 }
               )
              .then((resp) => {
                  this.showOverlay = false;
                  this.fetchIntroductionitems();
               })
              .catch(error => {

              });
            },
            FollowDate(value) {
              return moment(String(value)).utc().format('MM/DD/YYYY')
            },
            sortMethod: function(field) {
             this.sortField = field;
             if(this.sortBy == 'ASC') {
               this.sortBy = 'DESC';
             }
             else {
               this.sortBy = 'ASC';
             }
             this.fetchIntroductionitems();
           },
           showTasklistofPaginated() {
               this.fetchIntroductionitems();
               this.filterFlag = false;
            },
            filterIntroductionitems() {
               this.filterFlag = true;
               this.fetchIntroductionitems();
            },
           fetchUserOptions: function() {
             axios.get('/masteradmin-useroptions', {

             })
             .then((response) => {
                 var user_option = {value: '', text: 'Created By'};
                 this.user_options.push(user_option);
                 for(var i=0; i < response.data.length; i++) {
                   var name = response.data[i].first_name + ' ' + response.data[i].last_name;
                   var user_option = {value: response.data[i].id, text: name};
                   this.user_options.push(user_option);
                 }
             })
             .catch(error => {

             });

           },
           fetchAffiliateOptions: function() {
             axios.get('/affiliateoptions', {

             })
             .then((response) => {
                 var affiliate_option = {value: '', text: 'Select Affiliate'};
                 this.affiliate_options.push(affiliate_option);
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
             })
             .catch(error => {

             });

           },
           createIntroduction: function() {
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                  axios('/introduction-manager',
                     {
                       method: 'POST',
                       data:
                        {
                          introduction_title: this.introduction_title,
                          affiliate_selected: this.affiliate_selected,
                          roles_selected: this.roles_selected,
                          show_slide_numbers: this.show_slide_number_selected,
                        },
                     }
                   )
                  .then((resp) => {
                      this.introduction_title = '';
                      this.affiliate_selected = [];
                      this.roles_selected = [];
                      this.isModalVisible = false;
                      this.$emit('close');
                      this.$store.dispatch('introduction_template', '');
                      router.push("/introduction-slide-list/" + resp.data);


                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                  });

              }
            });
           },
            fetchIntroductionitems() {
              this.loading = true;
              if(this.filterFlag) {
                 this.currentPage = 1;
              }
              const params = { _page: this.currentPage }
              if (this.search_keyword) {
                params.title = this.search_keyword
              }
              if (this.search_status) {
                params.status = this.search_status
              }
              if (this.search_affiliate) {
                params.affiliate = this.search_affiliate
              }
              if (this.sortField) {
                params.sortfield = this.sortField
              }
              if (this.sortBy) {
                params.sortby = this.sortBy
              }
              axios.get('/introduction-manager', {
                 params: params
              })
              .then((resp) => {
                  this.loading = false;
                  this.introduction_lists = resp.data.data;
                  this.currentPage = resp.data.page;
                  this.rows = resp.data.total_rows;
              })
              .catch(error => {

              });
            },
           getStatus: function(status) {
             var status_val = this.status_options.findIndex(item => item.value === status);
             return this.status_options[status_val].text;
           },

            toggleDropdown (id) {
              document.getElementById(id).classList.toggle("show");
            },
            hideActionMenu(e) {
              var matches = document.getElementsByClassName('dropdown-content');
              for (var i=0; i<matches.length; i++) {
                var container = document.getElementById('dropdown-container'+ i);
                if (!container.contains(e.target)) {
                     if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                        document.getElementById('actionDropdown' + i).classList.remove('show');
                     }
                }
              }
            },
          },
          mounted() {
            document.addEventListener('click', this.hideActionMenu);
          },
          beforeDestroy() {
            document.removeEventListener('click', this.hideActionMenu);
          },
         created() {
           if((store.state.page_url) && (store.state.page_url === 'Tasklists')) {
             this.selectedComponent = store.state.active_tab;
           }
           var roles = store.state.roles;
           if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
             this.masterAdmin = true;
           }
           if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
             this.admin = true;
           }
           this.fetchUserOptions();
           this.fetchAffiliateOptions();
           this.fetchIntroductionitems();
         }
    }
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 30px;
  color: #FFF;
  padding: 3px 0px;
  margin-bottom: 0px;
  margin-right: 0px;
  margin-left: 0px;
}

.tasklist-item {
    padding: 12px 0px 12px 0px;
}
hr {
    border-top: 2px solid #8b8b8b;
    margin: 0px;
}
.no-assessment-text {
  font-size: 20px;
  color: #8b8b8b;
}
.mx-datepicker {
  width: 100%;
}
.custom-select {
  height: 35px;
}
</style>
<style>
.input-height-30 {
  line-height: 28px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected span::before,
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected.multiselect__option--highlight,
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: #fff !important;
}
.assessment-title {
  text-align: center;
  padding-top: 15px;
  padding-bottom: 15px;
  font-weight: bold;
  font-size: 16px;
}
.publish-content {
  padding: 10px 40px;
  text-align: center;
  font-size: 13px;
}
.scroll_box {
  padding: 0;
  display: flex;
  justify-content: end;
}
.scroll_up_down {
  background-color: #efac91;
  padding: 5px;
  text-align: center;
  width: 40px;
}
.angle_font {
  color: #FFF !important;
  font-size: 1.8rem !important;
}
.page_angle_down { margin: 10px 15px; }

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/introduction_manager_template.vue